import { render, staticRenderFns } from "./VueBookDemoPage.vue?vue&type=template&id=e103e258&"
import script from "./VueBookDemoPage.vue?vue&type=script&lang=ts&"
export * from "./VueBookDemoPage.vue?vue&type=script&lang=ts&"
import style0 from "./VueBookDemoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\2-Projects\\1-asva\\5-vue-book\\1-vue-book\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e103e258', component.options)
    } else {
      api.reload('e103e258', component.options)
    }
    module.hot.accept("./VueBookDemoPage.vue?vue&type=template&id=e103e258&", function () {
      api.rerender('e103e258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\components\\DemoPage\\VueBookDemoPage.vue"
export default component.exports